import { InvestorTeam } from '../../../../hooks/types';
import { kubernetesApi } from '../../../api';

export async function federationAssignInvestor(
  userId: string,
  customerId: string,
  active: boolean,
  isDedicated: boolean,
  customerName: string,
): Promise<InvestorTeam[] | false> {
  try {
    const response = await kubernetesApi.post(`/users/assign`, {
      userId,
      customerId,
      active,
      isDedicated,
      customerName,
    });
    const product = response.data as InvestorTeam[];

    return product;
  } catch (err) {
    console.error(
      `Ocorreu algum problema ao inserir investidor no projeto, atualize a página e tente novamente 😕`,
      err,
    );
    return false;
  }
}
